import { useContext, useEffect, useMemo } from 'react';
import { matchPath, useLocation, useParams } from 'react-router-dom';

import routes, { CourseParams } from '../../../pages/routes';
import { LayoutContext } from '../../../shared/Layout/Context';
import { CourseAnalyticsTab } from './types';

export const CourseAnalyticsTabIds = {
  [CourseAnalyticsTab.STUDENTS]: 'course-analytics-students-tab',
  [CourseAnalyticsTab.AVERAGES]: 'course-analytics-averages-tab',
};

export const CourseAnalyticsTabPanelIds = {
  [CourseAnalyticsTab.STUDENTS]: 'course-analytics-students-tabpanel',
  [CourseAnalyticsTab.AVERAGES]: 'course-analytics-averages-tabpanel',
};

export default function useCourseAnalyticsHeaderVM() {
  const { pathname } = useLocation();
  const params = useParams<CourseParams>();

  const activeTab = useMemo(() => {
    const routeMap = {
      [routes.courseAnalyticsStudents.path]: CourseAnalyticsTab.STUDENTS,
      [routes.courseAnalyticsAverages.path]: CourseAnalyticsTab.AVERAGES,
    };

    for (const [path, tab] of Object.entries(routeMap)) {
      if (matchPath({ path, end: true }, pathname)) return tab;
    }

    return CourseAnalyticsTab.STUDENTS;
  }, [pathname]);

  /** Tabs */

  const { setSelectedTabIds } = useContext(LayoutContext);

  useEffect(
    function onActiveTabChange() {
      setSelectedTabIds({
        tabId: CourseAnalyticsTabIds[activeTab],
        panelId: CourseAnalyticsTabPanelIds[activeTab],
      });
    },
    [setSelectedTabIds, activeTab]
  );

  useEffect(
    function onMount() {
      return function cleanup() {
        setSelectedTabIds(null);
      };
    },
    [setSelectedTabIds]
  );

  return { activeTab, params };
}
